import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import Navbar from '../components/Navbar';
import { setBulkLecture } from '../Redux/LectureReducer/action';
import { SET_BULK_LECTURE_SUCCESS } from '../Redux/LectureReducer/actionTypes';

export const CreateBulkLecture = () => {
    const dispatch = useDispatch();
    const user = useSelector((state) => state.AuthReducer.user);
    const token = useSelector((state) => state.AuthReducer.token)
    const [file, setFile] = useState('');

    const handleCreateBulkLecture = () => {
        const formData = new FormData();
        formData.append("file", file);
        dispatch(setBulkLecture(formData, token)).then((res) => {
            console.log(res,"shivam")
            if (res === SET_BULK_LECTURE_SUCCESS) {
                alert("Bulk lecture created")
            }
        })
    }

    return (
        <div className='font-sans antialiased min-h-screen bg-gray-100'>
            <nav>
                <Navbar name={user.name} role={user.roles.name} />
            </nav>
            <header className='bg-white shadow'>
                <div className='max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8 flex justify-between'>
                    <h2 className='font-semibold text-xl text-start text-gray-800 leading-tight'> Create Lecture</h2>
                </div>
            </header>
            <div className='p-12 '>
                <div className='bg-white grid shadow-md border-0 rounded-md grid-cols-4 p-6 m-auto gap-4 w-96'>
                    <div className='bg-white text-left col-span-3'>
                        <label className='block font-medium text-sm text-gray-700'>Select CSV file</label>
                        <input
                            className='font-medium text-sm text-gray-700'
                            type={"file"}
                            accept={".csv"}
                            onChange={(e) => setFile(e.target.files[0])}
                        />
                    </div>
                    <div className='col-start-3 col-end-6 m-2'>
                        <button onClick={handleCreateBulkLecture} className='border rounded-md border-trensparent py-2 px-4 bg-gray-800 hover:bg-gray-700 focus:bg-gray-900 focus:outline-none text-white text-xs font-semibold uppercase cursor-pointer '>Create Lectures</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
